import { useMemo } from "react";
import { useChosenDepartment } from "../../contexts/ChosenDepartment";
import { useTeamRoster } from "../../hooks/useTeamRoster";
import type { NurseFullRole } from "../../utils/models";
import { getDepartmentNurseTypes } from "../../utils/utilFunctions";

/** The roles the Team page filters and prices by, read from the Team roster rather than `hospitalData.nurses`. */
export const useTeamNurseTypes = (): NurseFullRole[] => {
	const { chosenDepartment } = useChosenDepartment();
	const { roster } = useTeamRoster(chosenDepartment.department_id);
	return useMemo(() => getDepartmentNurseTypes(chosenDepartment.roles, roster), [chosenDepartment.roles, roster]);
};
